import { forwardRef } from "react";
import { required, useInput } from "react-admin";

import { BssidField } from "./BssidField";

interface Props {
  source: string;
  label?: string;
  placeholder?: string;
}

export const BssidFieldWrapper = forwardRef(({ source, ...props }: Props, ref) => {
  const { field } = useInput({
    source,
    defaultValue: [],
    validate: [required()]
  });

  return <BssidField {...props} {...field} ref={ref} helperText="Separate BSSIDs with ENTER" />;
});
